<template>
  <a :target="this.noRedirect ? '_self' : '_blank'" rel="noopener" class="visible-link" :href="url">
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'TextLink',
  props: {
    url: String,
    noRedirect: Boolean,
  },
};
</script>
